export default "__VITE_ASSET__MTbHMD3m__"